import store from '@/store/store';

import App from '@/components/App';
import Home from '@/components/Home';
import TableauDeBord from '@/components/tableauDeBord/index';
import VenteFacesLc from '@/components/creationOpportunite/venteFacesLc/index';
import ClientProspect from '@/components/clientProspect/recherche/index';
import VenteReseauxTempo from '@/components/creationOpportunite/venteReseauxTempo/index';
import Connexion from '@/components/connexion/connexion';
import DemoComposants from '@/components/demoComposants/demoComposants';
import LoginRequired from '@/loginRequired';
import FicheClient from '@/components/clientProspect/ficheClient/index';
import Panier from '@/components/creationOpportunite/panier/index';
import MesOpportunites from '@/components/mesOpportunites/recherche/index';
import MesCommandes from '@/components/mesOpportunites/commande/index';
import VenteReseauxLC from '@/components/creationOpportunite/venteReseauxLc/index';
import DetailOpportunite from '@/components/mesOpportunites/detail/index';
import VenteNumerique from '@/components/creationOpportunite/venteNumerique/index';
import VenteReseauxNumerique from '@/components/creationOpportunite/venteReseauxNumerique/index';
import Parametrage from '@/components/general/parametrage';
import Panneaux from '@/components/panneaux/index';
import { PAGE_DEFAULT } from './routerConf';

export default [
  {
    path: '/connexion',
    component: Connexion,
  },
  {
    path: '/demo-composants',
    name: 'Style',
    component: DemoComposants,
  },
  {
    path: '/',
    name: 'App',
    component: App,
    children: [
      {
        path: '/home',
        redirect: '/tableau-de-bord',
      },
      {
        path: '/home',
        component: Home,
      },
      {
        path: '/tableau-de-bord',
        component: TableauDeBord,
      },
      {
        path: '/vente-faces-LC',
        component: VenteFacesLc,
        name: 'vente-faces-LC',
      },
      {
        path: '/panneaux/:type',
        component: Panneaux,
        name: 'panneaux',
      },
      {
        path: '/client-prospect',
        component: ClientProspect,
      },
      {
        path: '/vente-reseaux-temporaires',
        component: VenteReseauxTempo,
      },
      {
        path: '/fiche-client/:num',
        component: FicheClient,
        name: 'ficheclient',
      },
      {
        path: '/panier',
        component: Panier,
      },
      {
        path: '/mes-opportunites',
        component: MesOpportunites,
        name: 'mesOpportunites',
      },
      {
        path: '/mes-commandes',
        component: MesCommandes,
      },
      {
        path: '/detail-opportunite/:id',
        component: DetailOpportunite,
        name: 'detailopportunite',
      },
      {
        path: '/vente-reseaux-LC',
        component: VenteReseauxLC,
      },
      {
        path: '/vente-ecrans-numeriques',
        component: VenteNumerique,
        name: 'vente-ecrans-numeriques',
      },
      {
        path: '/vente-reseaux-numeriques',
        component: VenteReseauxNumerique,
      },
      {
        path: '/parametrage',
        component: Parametrage,
      },
      {
        path: '*',
        redirect: PAGE_DEFAULT,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (LoginRequired(store)) {
        next();
      } else {
        next('/connexion');
      }
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js